import loadable from '@loadable/component'

export const RelatedResearch = loadable(() => import('./RelatedResearch'))
export type { RelatedResearchProps } from './RelatedResearch'
